<template>
  <v-tooltip
    :open-delay="tooltipDelay"
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span class="mx-1" v-on="on" v-if="enableToolTip">
        <v-btn
          :id="id"
          style="background-color: transparent !important;"
          :class="myClass"
          v-bind="computedProps"
          v-on="computedListeners"
          :elevation="0"
          :loading="loading"
          :min-width="minWidth"
          :width="minWidth"
          :disabled="disabled"
          :text="text"
          :x-small="xsmall"
          :small="small"
          :large="large"
          :x-large="xlarge"
        >
          <slot></slot>
        </v-btn>
      </span>
      <span class="mx-1" v-else>
        <v-btn
        :id="id"
          style="background-color: transparent !important;"
          :class="myClass"
          v-bind="computedProps"
          v-on="computedListeners"
          :elevation="0"
          :loading="loading"
          :min-width="minWidth"
          :width="minWidth"
          :disabled="disabled"
          :text="text"
          :x-small="xsmall"
          :small="small"
          :large="large"
          :x-large="xlarge"
        >
          <slot></slot>
        </v-btn>
      </span>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
/**
 * @file DDv2用標準ボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
<dd-transparent-button
  [atmark]click="DdTransparentButtonOnClick">
  検索
</dd-transparent-button>
 */
export default {
  name: 'DdTransparentButton',

  // プロパティ定義
  props: {
    id: String,
    addClass: {
      Type: String,
      default: ''
    },
    minWidth: {
      type: Number,
      default: 80
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    /**
     * ボタンサイズ
     */
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipDelay: {
      type: Number,
      default: 1000
    }
  },
  data: () => ({
  }),
  computed: {
    computedProps () {
      // xlarge/xsmallはv-btn側のプロパティ名(xLarge/xSmall)とcase違いで警告が出るため、
      // 既にx-large/x-smallとして個別にバインドしている分は除いて渡す
      const { xlarge, xsmall, ...rest } = this.$props
      return {
        ...rest,
        dense: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    myClass () {
      return 'zoom-hover' + ([undefined, null, ''].includes(this.addClass) ? '' : ' ' + this.addClass)
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
<style scoped>
i::before {
  color: darkslategray !important;
}
</style>
